module.exports = {
    blog_title:'Blog de Taption',
    blog_desc:'Des articles utiles et des conseils pour les créateurs. Mises à jour de produits, actualités et informations sur Taption.',
    written_by: 'Écrit par', 
}
